<template>
  <Transition name="fade">
    <div v-if="goods.length" class="lesson-item">
      <ul class="goods-list">
        <li v-for="item in goods" :key="item.clID">
          <RouterLink
            target="_blank"
            :to="`/video/videodetail?clID=${item.clID}&id=${item.id}`"
          >
            <img v-lazy="item.coverImg" alt="" />
            <div class="pr-tag">
              <i class="pr-year" title="课程年份">{{ item.grade.grYear }}</i>
              <i class="pr-way" title="学习方式">{{
                item.grade.prTeachWayName
              }}</i>
            </div>
            <p class="grade" v-if="item.grade.grName.length <= 4">
              {{ item.grade.grName }}
            </p>
            <p class="grade1" v-if="item.grade.grName.length > 4">
              {{ item.grade.grName }}
            </p>
            <p class="name ellipsis-2">{{ item.leName }}</p>
            <div class="price">
              <span class="old-price">&yen;{{ item.grade.grPrice }}</span>
              <span class="new-price">&yen;{{ item.grade.salePrice }}</span>
            </div>
          </RouterLink>
        </li>
      </ul>
    </div>
    <HomeLessonSkeleton v-else />
  </Transition>
</template>

<script>
import HomeLessonSkeleton from "./lesson-home-skeleton.vue";
export default {
  components: {
    HomeLessonSkeleton,
  },
  props: {
    goods: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.lesson-item {
  //position: relative;
  .goods-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 995px;
    height: 300px;
    margin-left: 5px;
    li {
      position: relative;
      width: 243px;
      height: 300px;
      margin-right: 7.665px;
      margin-bottom: 10px;
      background: #f4f4f4;
      &:nth-child(4n) {
        margin-right: 0px;
      }
      &:nth-last-child(-n + 4) {
        margin-bottom: 0;
      }
      .pr-tag {
        display: inline-block;
        position: absolute;
        top: 0px;
        right: 0px;
        .pr-way {
          height: 20px;
          text-align: center;
          line-height: 20px;
          color: #fff;
          font-size: 12px;
          background: @shColor;
          border-radius: 5px;
          padding-left: 5px;
          padding-right: 5px;
        }
        .pr-year {
          height: 20px;
          text-align: center;
          line-height: 20px;
          color: #fff;
          font-size: 12px;
          background: @shColor;
          border-radius: 5px;
          padding-left: 5px;
          padding-right: 5px;
          margin-right: 5px;
        }
      }
      .grade {
        position: absolute;
        font-weight: bold;
        top: 47.5%;
        left: 37.37%;
      }
      .grade1 {
        position: absolute;
        font-weight: bold;
        top: 47.5%;
        left: 31.37%;
      }

      .hoverShadow();
      img {
        width: 306px;
        height: 200px;
        border-radius: 8px;
      }
      p {
        height: 60px;
        font-size: 16px;
        padding: 11px 15px 0 5px;
        text-align: left;
      }
      span {
        padding: 5px 15px 0 5px;
        text-align: left;
      }
      .price {
        display: flex;
        justify-content: space-around;
        .old-price {
          padding-left: 8px;
          color: @priceColor;
          font-size: 16px;
          height: 16px;
          text-decoration: line-through;
        }
        .new-price {
          margin-left: 8px;
          color: @priceColor;
          font-size: 16px;
          height: 16px;
        }
      }
    }
  }
}
</style>
